import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/themeco': {
    width: 441,
    height: 512,
    paths: [
      {
        d: 'M199.7 12.3C209.5 6.6 225.3 6.6 235.1 12.1L423.3 118C433.1 123.6 441 137.2 441 148.4V362.3C441 373.5 433.1 387.2 423.3 392.7L235.1 499.9C225.3 505.4 209.5 505.4 199.8 499.7L17.6 392.9C7.9 387.3 0 373.5 0 362.3V148.4C0 137.1 7.9 123.4 17.6 117.8L199.7 12.3zM123.5 209C107.8 209 92.2 209.1 76.5 209.1V309H95.3V279.6H123.5C172.5 279.6 172.3 209 123.5 209zM261.5 307.7L231.3 273.6C267.6 266.2 265.5 209.4 220.6 209.1 204.7 209.1 188.9 209 173 209V309H191.9V275.6H210L239.1 309H261.5V307.7zM220.6 226.7C243.5 226.7 243.5 258.6 220.6 258.6H191.9V226.7H220.6zM126.5 225.1C147.3 225.1 147.3 263.4 126.5 263.4H94.7V225.1L126.5 225.1zM316.1 207.2C248.7 207.2 246.3 311.3 316.1 311.3 384.5 311.3 384.5 207.2 316.1 207.2zM316.1 224.3C359.6 224.3 360.2 294 316.1 294 272 294 272.4 224.3 316.1 224.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/themeco.js
// module id = mgbz
// module chunks = 144